<script setup>
import { defineProps, onMounted, watch } from 'vue'

import { Pagination } from '../../ui/pagination/index.js'
import { storeToRefs } from 'pinia'
import UmisisDataList from './UmisisDataList.vue' // Placeholder

// 1. Define ALL props for the component, including selection props
const props = defineProps({
  fields: {
    type: Array,
    default: () => []
  },
  useStore: {
    type: Object,
    required: true
  },
  loadingRowCount: {
    type: Number,
    default: 10,
  },
  rowClass: {
    type: Function,
    default: () => (row) => ''
  },
  selectable: {
    type: Boolean,
    default: false
  },
  cards: {
    type: Boolean,
    default: false
  }
});

const { page, perPage, total, isLoading, orderDirection, orderBy, getItems, filterByField, filterValue, searchQuery } = storeToRefs(props.useStore);


watch(
  [
    page,
    perPage,
    orderBy,
    orderDirection,
    filterByField,
    filterValue,
    searchQuery
  ],
  async () => {
    // This runs automatically whenever any of these change
    console.log('Store parameters changed:', page.value, perPage.value, orderBy.value, orderDirection.value, filterByField.value, filterValue.value, searchQuery.value );
    await props.useStore.fetchItems(); // Replace 'fetchData' with your actual action name
  }
);

const handleSort = (params) => {
  // Call the store action directly
  props.useStore.sortChanged(params);
};

const handleSearch = (params) => {
  // Call the store action directly
  console.log('search changed:', params);
  props.useStore.searchChanged(params);
};

const handleFilters = (filters) => {
  // Call the store action directly
  console.log('Filters changed:', filters);
  //props.useStore.filtersChanged(filters);
};



onMounted(() => {
  props.useStore.fetchItems()
})

</script>

<template>
  <UmisisDataList :cards="props.cards" :loading="isLoading" :order-direction="orderDirection" :order-by="orderBy" :fields="fields" :rows="getItems" @search-changed="handleSearch" @filters-changed="handleFilters" @sort-changed="handleSort">
    <!-- Slot for overriding specific cells, for using with the Actions column, for example -->
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name="name" v-bind="slotData" />
    </template>
  </UmisisDataList>
  <Pagination v-model:page="perPage" v-model:items-per-page="page" :total="total" />
</template>
